import $ from 'jquery';
import setupBisAndSo from '../../modules/bis-and-so';
import addToBag from './add-to-bag';
import wishlist from 'modules/wishlist';
import "jquery-lazy/plugins/jquery.lazy.ajax";
import cookies from 'js-cookie';
import './jquery-zoom';
import 'styleguide/modules/slides';
import customPaging from "../../../../styleguide/src/assets/modules/slick/custom-paging";
import { trackPsykhePdpView } from "../../modules/psykhe";

import { renderPdpSocialProof } from "../../modules/social-proof";

function showSizeGuidePopup()
{
    var data = $.param({
        "measurements" : $("#size_and_fit_link").data("measurements"),
        "measuretable" : $("#size_and_fit_link").data("measuretable"),
        "international" : $("#size_and_fit_link").data("international"),
        "bullets" : $("#size_and_fit_link").data("bullets")
    });

    $.modal({
        url: $("#size_and_fit_link").data("url"),
        data: data,
        triggerOpen: true,
        closeButton: true,
        returnFocus: '#size_and_fit_link',
        onComplete : function(){
            $('.close_btn').hide();
            $('.modal__content').focus();
            $(".sizeguide_measurement").click(
                convertSize
            );
        }
    });
}

function showBisPopup(element)
{
    let link = element.data("url");
    let elementSelector = '#' + element.attr('id');
    $.modal({
        url: link,
        triggerOpen: true,
        triggerElement: $(element),
        closeButton: true,
        type : 'small',
        returnFocus: elementSelector,
        onComplete : setupBisAndSo
    });
}


function convertSize()
{
    $(".sizeguide_measurement").removeClass("active");
    $(this).addClass("active");

    if ($(this).text()=="IN")
    {
        $(".sizeToConvertInch").show();
        $(".sizeToConvertCM").hide();
    }
    else{
        $(".sizeToConvertCM").show();
        $(".sizeToConvertInch").hide();
    }
}

function getWishListSelectedSize(){
    var size = '';
    if($("#one-size-div:visible").length > 0 ||
        $("#product_info").data("onesize")) {
        size = 'all';
    }else{
        if($.trim($("#size-select option:selected").val()) ){
            size = $.trim($("#size-select option:selected").val());
        }
    }
    return size;
}

function submitNotifyMe(code, size, email, callback){
    let data = $.param({
        size : size,
        email : email,
        code : code,
        fw : true
    });

    $.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function(msg){
        if(callback){
            callback();
        }
    });
}

function validateEmail(emailStr) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(emailStr);
}

// NOTE: must match java functions ([^a-zA-Z0-9])
function getHTMLJSSaveId(value) {
    return value.replace(/[\W_]+/g,"");
}

function bindEditorPickEvent() {
    $('.js-editor-pick-modal').on('click', function(e) {
        e.preventDefault();
        const $el = $(this);
        const productCode = $el.data('productCode');
        const lookIndex = $el.data('lookIndex');

        $.modal({
            url: $el.data('modalUrl'),
            data: {
                code: productCode,
                index: lookIndex
            },
            type: 'large',
            triggerOpen: true,
            addModifierClass: 'modal--lg-height',
            onComplete: () => {
                bindEditorPickProductLazy();
                bindEditorPickAddToBagEvent();
                bindEditorPickPdpEvent();

                $('.js-editor-pick-carousel').each((i, item) => {
                    const $item = $(item);
                    const $slickSlides = $item.find('.js-slides-slick');
                    $item.slides({
                        arrows: true,
                    });
                    $slickSlides.slick('slickGoTo', lookIndex);
                    $slickSlides.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
                        const $productsContent = $('#editor-pick-products-content');
                        const $loader = $('#editor-pick-progress-bar');

                        $productsContent.addClass('u-hide');
                        $loader.find('.progress-bar').css('left', '75%');
                        $loader.removeClass('u-hide');

                        $.ajax({
                            url: $item.data('productsUrl'),
                            data: {
                                code: productCode,
                                index: nextSlide
                            },
                            success: (data) => {
                                $productsContent.html(data);
                                bindEditorPickProductLazy();
                                bindEditorPickAddToBagEvent();
                                bindEditorPickPdpEvent();

                                $productsContent.removeClass('u-hide');
                                $loader.addClass('u-hide');
                                $loader.find('.progress-bar').removeAttr('style');
                            }
                        });
                    });
                });
            }
        });

        if (typeof logEngagement === 'function') {
            logEngagement(window.location.href, 'editors picks', 'open');
        }
    });
}

function bindEditorPickPdpEvent() {
    $('.js-modal-editorial-pdp').on('click', function (e) {
        e.preventDefault();

        const $el = $(this);
        const $editorPickContent = $('#editor-pick-content');
        const $loader = $('#editor-pick-progress-bar');

        $editorPickContent.addClass('u-hide');
        $loader.removeClass('u-hide');

        $.ajax({
            url: $el.data('url'),
            data: {
                productCode: $el.data('code')
            },
            success: (data) => {
                const $pdpContent = $('#editor-pick-pdp-content');
                $pdpContent.html(data);

                $('.js-editor-product-carousel').each(function(i, item) {
                    const $item = $(item);

                    $item.slides({
                        arrows: true,
                    });
                });
                bindEditorPickAddToBagEvent();
                $('#back-button').on('click', () => {
                    $pdpContent.addClass('u-hide');
                    $editorPickContent.removeClass('u-hide');
                    if (typeof logEngagement === 'function') {
                        logEngagement(window.location.href, 'editors picks', 'back to editors picks');
                    }
                });

                $pdpContent.removeClass('u-hide');
                $loader.addClass('u-hide');
            }
        });

        if (typeof logEngagement === 'function') {
            logEngagement(window.location.href, 'editors picks', 'view more details');
        }
    });
}

function bindEditorPickProductLazy() {
    $('.js-editor-product-lazy').lazy({
        threshold: 2000,
        throttle: 25
    });
}

function bindEditorPickAddToBagEvent() {
    $('.js-editor-add-to-bag').on('click', function(e) {
        const $el = $(this);
        const $sizeSelect = $el.data('index') ? $(`#sizeSelect${$el.data('index')}`) : $('#sizeSelect');
        addToBag($el.data('code'), $sizeSelect.length ? $sizeSelect.val() : 'all', e);
        if (typeof logEngagement === 'function') {
            logEngagement(window.location.href, 'editors picks', 'atb');
        }
    });
}

$(function() {
    // JS from ImageCarousel
    let previousFocusElement = null;

     $('.js-pdp-image-zoom').on('keyup', function(e) {
        var key = e.which;
        if (key == 13) {
            e.preventDefault();
            previousFocusElement = (document.activeElement || document.body);
            $(this).click();
            }
    })

    $('.modal__close--btn').on('keyup', function(e) {
        var key = e.which;
        if (key == 13) {
          previousFocusElement.focus();
          previousFocusElement = null;
        }
    })

    /**
     * Custom Slick and JQuery Zoom Options for PDP Full Image View
     */
    const fullProductImageView = (startIndex = 0) => {

        /* Initialize Jquery Zoom  */
        const initZoom = ($carousel) => {

            const $zoomActive = $carousel.find('.slick-active');

            // Clear any existing zoom instances first
            $carousel.find('.js-pdp-image-zoom.zoom-active').each(function() {
                $(this).trigger('zoom.destroy');
                $(this).removeClass('zoom-active');
            });

            // Initialize zoom on active slides
            $zoomActive.each(function(i, el) {

                // Set cursor to crosshair
                el.style.cursor = "crosshair";

                const $zoomContainer = $(el).find('.js-pdp-image-zoom');
                const zoomImgUrl = $zoomContainer.data('zoom-img');

                if (zoomImgUrl && !$zoomContainer.hasClass('zoom-active')) {
                    $zoomContainer.zoom({
                        on: 'click-n-grab', // NEW: Mouse Event for settings option
                        magnify: 2,
                        // ONLY works when on is set to click-n-grab
                        moveDirection: 'reverse', // Set to 'reverse' for inverted drag
                        onZoomIn: function () {
                            el.style.cursor = "grab";
                        },
                        onZoomOut: function () {
                            el.style.cursor = "crosshair";
                        }
                    });
                    $zoomContainer.addClass('zoom-active');
                }
            });
        }

        const $carousel = $('.js-slides-zoom');

        if(!$carousel.hasClass('slick-initialized')) {
            // If product has 2 prod-imgs, show both imgs in zoomCarousel when 2nd prod-img is clicked
            const slidesToShow = 2;
            const slideCount = $carousel.find('.js-pdp-image-zoom').length;
            const initialSlide = slideCount > slidesToShow
                ? startIndex
                : Math.max(0, Math.min(startIndex, slideCount - slidesToShow));

            $carousel.on('init', function(event, slick) {
                initZoom($carousel);
            })
            .on('afterChange', (event, slick) => {
                initZoom($carousel);
            });

            $carousel.slides({
                slidesToShow,
                slidesToScroll: 1,
                nextArrow: $('#pdp-zoom-modal').find('.slick-next'),
                prevArrow: $('#pdp-zoom-modal').find('.slick-prev'),
                draggable: false, // Helps w/ click drag functionality
                initialSlide,
            });
            $('.pdp__image').removeClass('u-hide');

        }
    }


    // Conditional markup for 2 Column Carousel
    if ($('.pdp__main-slideshow').hasClass('js-pdp-slides')) {
        // This block of code ensures that the modal doesn't open when a user is swiping through slick carousel.
        // A dragging flag was added and also a flag was added, "wasInitialMouseDownOnEl", to ensure that the modal
        // only opens if the initial mouse down and mouse up were done on the same $el element.
        let isDragging = false;
        let wasInitialMouseDownOnEl = false;
        const $el = $('.js-slides-slick');

        $(window).on('mousedown.modal', function(evt) {
            isDragging = false;
            wasInitialMouseDownOnEl = false;

            // Mousedown was done initially on the el
            if ($(evt.target).closest($('.js-slides-slick')).length > 0) {
            wasInitialMouseDownOnEl = true;
            }

            $(window).on('mousemove.modal', function() {
                isDragging = true;
                $(window).off("mousemove.modal");
            });
        });

        function loadMainZoomModal(returnFocus, slickIndex) {

            var data = $.param({
                code: $('.pdp__main-slideshow').data('code'),
                url: window.location.href
            });

            $.modal({
                url: '/fw/content/product/mainZoomModal',
                triggerOpen: true,
                type: 'full',
                data: data,
                cache: true,
                returnFocus: $(returnFocus),
                // The button is display:none'd while the modal is open (focusout hides it),
                // and a hidden element can't receive focus. Re-show it before the modal
                // returns focus to it on close.
                onClose: () => $('.product-zoom__btn').off('transitionend').show().addClass('product-zoom__btn--active'),
                onComplete: () => fullProductImageView(slickIndex),
            });
        }

        $('.js-slides-slick').on('mouseup', function(e) {
            var $li = $(e.target).closest('.slick-slide');
            var slickIndex = $li.data('slick-index');
            // Find the leftmost visible slide in the current view
            // Check if there's a slide to the left that's also visible
            var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
            var adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
            if (!isDragging && wasInitialMouseDownOnEl) {
                e.preventDefault();
                loadMainZoomModal(previousFocusElement, adjustedIndex);
            }
        });
        $('.js-slides-slick').on('keyup', evt => {
            var enterKey = evt.keyCode === 13;
            // The zoom button is inside the carousel and has its own click
            // handler that also fires on Enter; bail out here so the modal
            // doesn't open twice.
            if ($(evt.target).closest('.product-zoom__btn').length) {
                return;
            }
            var $li = $(evt.target).closest('.slick-slide');
            var slickIndex = $li.data('slick-index');
            // Find the leftmost visible slide in the current view
            var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
            var adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
            if (enterKey) {
                loadMainZoomModal($(evt.target), adjustedIndex);
            }
        });

        // "click to zoom" button opens the same zoom modal, starting on the
        // currently-active slide and returning focus to the button on close.
        $('.product-zoom__btn').on('click', function(e) {
            e.preventDefault();
            var slickIndex = $('.js-slides-slick .slick-active').first().data('slick-index') || 0;
            loadMainZoomModal($(this), slickIndex);
        });

    } else {
        $('.js-pdp-image-zoom').click(function (e) {
            e.preventDefault();
            console.log(e.target);
            var data = $.param({
                code: $('.pdp__main-slideshow').data('code'),
                url: window.location.href
            });
            var $li = $(e.target).closest('.slick-slide, li'); /* UX-20577 - add li */
            var slickIndex = $li.data('slick-index');

            $.modal({
                url: '/fw/content/product/mainZoomModal',
                triggerOpen: true,
                type: 'full',
                data: data,
                cache: true,
                triggerElement: previousFocusElement,
                onComplete: () => fullProductImageView(slickIndex),
            });
        });
    }

    // Two image PDP Carousel
    $('.js-pdp-slides').slides({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        appendDots: $('.js-pdp-dots'),
        customPaging,
        waitForAnimate: false,
        dotsClass: "image-carousel__dots",
        nextArrow: $('.js-pdp-slides').find('.slick-next'),
        prevArrow: $('.js-pdp-slides').find('.slick-prev'),
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        showZoomTab: true,
    });


    $('.js-special-order-request').on('click', function() {
        const url = $(this).data('url');
        if (url) {
            $.modal({
                url: url,
                triggerOpen: true,
                type: 'small',
                onComplete: function () {
                    $(".js-tabs").tabs();
                    $('.modal__content').find('[data-tab-content=".so-content"]').click();
                    setupBisAndSo();
                }
            })
        } else {
            console.log('Missing URL for special order');
        }
    })
    $('.js-oos-similar').slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
              breakpoint: 834,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
          ],
    })

    if ($('#back-in-stock').length) { // OOS PDP redesign AB test with exposed Notify Me form
        setupBisAndSo();
    }
    $('.js-product-swatch').on('click', function(){
        let url = $(this).data('swatch-url');
        const sizeEl = $('input[name="size-options"]:checked');
        if (sizeEl) {
            const sizeLabel = sizeEl.data('sizeLabel');
            if (sizeLabel && sizeLabel.length > 0) {
                url = removeParamFromURL(url, "size");
                url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({size: sizeLabel});
            }
        }
        window.location.href = url;
    });

    function removeParamFromURL(path, param) {
        path = path.replace(new RegExp("[&]+" + param + "=[^&\\b]*", "g"), '');
        path = path.replace(/\?&+/, '?');
        return path.replace(new RegExp("&{2,}", "g"), '&');
    }

    $("#lazy-styled-with").lazyAjax({
        afterLoad: () => {
            if($("#pdp-ctl").length) {
                var tabToClick = $('#pdp-info-tabs');
                var tabToActivate = $('#pdp-details');
                if($("#style-with-tab").length) {
                    tabToActivate = $('#lazy-styled-with');
                    tabToClick = $('#style-with-tab');
                }
                $('#pdp-info-tabs').show();
                $('.js-pdp-tabs').tabs();
                if(!$(".pdp.pdp--oos").length) {
                    tabToActivate.addClass('tabs__content--active');
                    tabToClick.click();
                } else {
                    tabToClick.one('click', function() {
                        $(".js-carousel-ctl").slick('refresh');
                    });
                }

                $(".js-carousel-ctl").slick({
                    dots: true,
                    customPaging,
                    dotsClass: "image-carousel__dots",
                    appendDots: $(".image-carousel__dots-container"),
                    lazyLoad: "ondemand",
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    accessibility: true,
                });
                $('.js-carousel-ctl').on('beforeChange', function(){
                  // removes dynamic content added in afterChange event
                  $('.current-element').remove();
                });
                $('.js-carousel-ctl').on('afterChange', function(){
                  // adds copy to content in custom paging to trigger aria-live assertive
                  $('.image-carousel__dots .slick-active .u-screen-reader').append('<span class="current-element">currently selected</span>');
                });
            } else {
                $('#lazy-styled-with').remove();
                $('#style-with-tab').closest('li').remove();
                $('#beauty-style-with').remove();
                $('#pdp-info-tabs').show();
                $('.js-pdp-tabs').tabs();
                $('#pdp-details-tab').click();
            }
        }
    });
    const $recommended = $('#lazy-recommended');
    $recommended.lazyAjax({
        afterLoad: () => {
            $('#ymal-exp-slidedown.js-slidedown').slidedown();
            $('.js-toggle-reveal').toggleReveal();
            $('.js-lazy-image').lazy();
        }
    });

    const $moreFromBrand = $('#lazy-more-from-brand');
    $moreFromBrand.lazyAjax({
        afterLoad: () => {
            if ($moreFromBrand && $moreFromBrand.html().trim() === '') {
                $moreFromBrand.remove();  // remove if no response since there's a min-height
            } else {
                // The reserved min-height is sized for the taller YMAL grid; the carousel is a single row.
                $moreFromBrand.css('min-height', 0);

                $moreFromBrand.find('.js-carousel--more-from-brand').each(function () {
                    const $this = $(this);
                    $this.slickSlider({
                        lazyLoad: 'progressive',
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        nextArrow: $this.children('.slick-next'),
                        prevArrow: $this.children('.slick-prev'),
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 4
                                }
                            }
                        ]
                    });
                });
            }
        }
    });

    const $recentlyViewed = $('#lazy-recently-viewed');
    $recentlyViewed.lazyAjax({
      afterLoad: () => {
          if ($recentlyViewed && $recentlyViewed.html().trim() === '') {
              $recentlyViewed.remove();  // remove if no response since there's a min-height
          } else {
              //bind events here
              var recentlyViewedCookieName = "recentlyViewedItems";
              var recentlyViewedCookieValue = cookies.get(recentlyViewedCookieName);
              var recentlyViewedItems = $recentlyViewed.find('.gc').length;

              if (recentlyViewedCookieValue != 10) {
                  cookies.set(recentlyViewedCookieName, recentlyViewedItems, {expires: 14});
              }

              $(".js-plp-lazy-img").lazy({
                  bind: "event",
                  effect: "show",
                  effectTime: 0,
                  threshold: 900,
                  throttle: 30,
              });
          }
      },
    });

    $('#lazy-editor-pick').lazyAjax({
       afterLoad: () => {
           $('.js-editor-list-carousel').each(function(i, item) {
               const $item = $(item);
               $item.slickSlider({
                   slidesToShow: 4,
                   slidesToScroll: 4,
                   nextArrow: $item.find('.js-slick-next'),
                   prevArrow: $item.find('.js-slick-prev')
               });
           });

           bindEditorPickEvent();
       }
    });

    const $personalizedRecsContainer = $('#lazy-recommended-for-you');
    $personalizedRecsContainer.lazyAjax({
        afterLoad: () => {
            if ($personalizedRecsContainer && $personalizedRecsContainer.html().trim() === '') {
                $personalizedRecsContainer.remove();  // remove if no response since there's a min-height
            } else {
                //Initialization for carousels - AB Test 765
                $('.js-carousel--seven').each(function () {
                    const $this = $(this);
                    $this.slickSlider({
                        lazyLoad: 'progressive',
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        nextArrow: $this.children('.slick-next'),
                        prevArrow: $this.children('.slick-prev'),
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 4
                                }
                            }
                        ]
                    });
                });
                // End of code for AB Test 765
            }
        }
    });

    $("#size_and_fit_link").click(function (event) {
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;

        showSizeGuidePopup();
    });

    $("#size_and_fit_link2").click(function (event) {
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
        showSizeGuidePopup();
    });

    $("#bis-and-so-trigger, #bis-button, #instock-notify").click(function (event) {
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
        showBisPopup($(this));
    });

    wishlist.bindPDPWishListEvent();

    $('.btn--add-to-bag').click(function(e){
        var selectedLabel = $('.pdp__size-btn input:checked').siblings('label[aria-disabled="true"]');
        if (selectedLabel.length > 0) {
            $('#size-selection-label').html($('#size-selection-label').data('select-unavailable-error-text'));
            $('#size-selection-label').addClass("u-error");
            e.preventDefault();
            return;
        }

        e.preventDefault();
        var code = window.rcProps.pdp.code;
        if(!code) return;
        if($('#pdp-sizes input:checked').length == 0){
            $('#size-selection-label').html($('#size-selection-label').data('select-error-text'));
            $('#size-selection-label').addClass("u-error");
            return '';
        }
        var size = $('#pdp-sizes input:checked').val();

        addToBag(code, size, e);
    });



    $('#pdp-sizes input').change(function () {
        var el = $(this);
        var href = el.attr('data-href');
        if(href){
            return;
        }

        var oneLeft = el.data('oneLeft');
        var finalSale = el.data('finalSale');
        var allSizeFinalSale = ($('.js-all-final-sale:visible').length > 0);
        var isPreorder = el.data('preorder');
        var defectiveDisclaimer = el.data('defect-disclaimer');
        var estDeliveryDate = el.data('delivery-date');
        var sizeLabel = $('#size-selection-label');
        var oneSize = el.val() === 'all';
        var showEstDeliveryDate = $('#pdp-delivery-date').data('show-delivery') || isPreorder;

        sizeLabel.removeClass("u-color--grey");
        sizeLabel.html(el.data('size-label'));

        var addToBagBtn = $('.btn--add-to-bag');
        var estimatedText = $('#js-est-text');
        if(isPreorder){
            sizeLabel.html(el.data('size-label') + " " + sizeLabel.data('preorder'));
            addToBagBtn.attr('aria-label', addToBagBtn.data('aria-label-preorder'));
            addToBagBtn.html(addToBagBtn.data('preorder-text'));
            estimatedText.html(sizeLabel.data('estimated-instock-text'));
            $('.preorder-msg').show();
        }else{
            addToBagBtn.attr('aria-label', addToBagBtn.data('aria-label-atb'));
            addToBagBtn.html(addToBagBtn.data('add-to-bag-text'));
            estimatedText.html(sizeLabel.data('estimated-delivery-text'));
            $('.preorder-msg').hide();
        }

        if(showEstDeliveryDate){
            if(estDeliveryDate){
                $('#js-est-date').html(estDeliveryDate);
                $('#pdp-delivery-date').show();
            }else{
                var defaultDeliveryDate = $('#pdp-delivery-date').data('default-est-date');
                if(defaultDeliveryDate !== ''){
                    $('#js-est-date').html(defaultDeliveryDate);
                    $('#pdp-delivery-date').show();
                }else{
                    $('#pdp-delivery-date').hide();
                }
            }
        } else {
            $('#pdp-delivery-date').hide();
        }

        var defectiveDiv = $('#final-sale-copy-defective');
        if(defectiveDisclaimer){
            defectiveDiv.html(defectiveDisclaimer).show();
        }else{
            defectiveDiv.html('').hide();
        }

        if(finalSale){
            if(!allSizeFinalSale){
                $('#size-selection-label').removeClass("u-error");
                sizeLabel.html(el.data('size-label') + " <span class='u-error'>" + sizeLabel.data('final-sale') + "</span>");
            }
            if(defectiveDisclaimer === ''){
                $('#final-sale-copy').show();
            }else{
                $('#final-sale-copy').hide();
            }

        }else{
            $('#size-selection-label').removeClass("u-error");
            $('#final-sale-copy').hide();
        }

        if(oneLeft){
            $('#size-selection-label').removeClass("u-error");
            if(isPreorder || (finalSale && !allSizeFinalSale && !oneSize)){
                sizeLabel.html(sizeLabel.html() + " <span class='u-error' aria-live='polite'>" + sizeLabel.data('one-left') + "</span>");
            }else{
                sizeLabel.html(el.data('size-label') + " <span class='u-error' aria-live='polite'>" + sizeLabel.data('one-left') + "</span>");
            }
        }


        var onSale = (el.data('price') !== el.data('regularPrice'));
        var priceMarkup ;
        const retailValueElement = $('.js-price-div').find('.js-retail-value');
        const retailValueMarkup = retailValueElement.length > 0 ? retailValueElement[0].outerHTML : ''; // https://stackoverflow.com/a/6459448
        if(onSale){
            if ($('.js-price-div').find('.price__sale').length > 0 || $('.js-price-div').find('.out-of-stock').length > 0) {
                $('.js-price-div').find('.price__sale').html(el.data('price-formatted'));
                $('.js-price-div').find('.price__retail').html(el.data('regular-price-formatted'));
            }else{
                priceMarkup = '<div class="price price--lg price--on-sale"><span class="price__sale u-margin-r--md">'+ el.data('price-formatted')+'</span>'
                    + '<span class="price__retail"><span class="u-screen-reader">Previous price:</span>'+ el.data('regular-price-formatted') +'</span>'+retailValueMarkup+'</div>';
            }
        } else {
            priceMarkup = '<div class="price price--lg"><span class="price__retail">'+ el.data('price-formatted')+'</span>'+retailValueMarkup+'</div>';
        }
        if(priceMarkup){
            $('.js-price-div').html(priceMarkup);
        }

        var afterPaySizes = document.getElementsByClassName('afterPayMsgBox');
        if (afterPaySizes.length > 0) {
            $('.afterPayMsgBox').hide();
        }
        var sizeStr = getHTMLJSSaveId(el.val());
        var afterPayElement = document.getElementById("afterPayBox" + sizeStr);
        if (afterPayElement) {
            $('.afterPayBoxMsg').hide();
            $('#afterPayBox' + sizeStr).show();    // show one if exists
        }
    });

    $(document).on('click', '.js-bis-and-so-link', function(e){
        e.preventDefault();
        var link = $(this).attr('href');

        $.modal({
            url: link,
            triggerOpen: true,
            triggerElement: $(this),
            type : 'small',
            onComplete : setupBisAndSo
        });
    });

    $('#pdp-color input').change(function(){
        var href = $(this).attr('data-href');
        if(href !== ''){
            location.href = href;
        }
    });

    $('#pdp-sizes input:checked').trigger('change');

    if (window.rcProps) {
        window.rcProps.ReCAPTCHACallBack = function () {
            $(".btn--add-to-bag").click();
        };
    }

    renderPdpSocialProof(window.rcProps.pdp.code);
    trackPsykhePdpView(window.rcProps.pdp.code,
      window.rcProps.pdp.productName,
      window.rcProps.pdp.price,
      window.rcProps.pdp.currency
    );
});

// Zoom Modal 2 Slide Desktop
$('.js-pdp-image-zoom--ab').on('click keydown', function (e) {
    if (e.type === 'click' || (e.type === 'keydown' && e.which === 13)) {
        console.log('keydown')
        e.preventDefault();
        var data = $.param({
            code: '$p.code',
            url: window.location.href
        });
        $.modal({
            url: '/ns/fw/2024/04_april/UX-16809/pdp-2-modal.html',
            triggerOpen: true,
            type: 'full',
            data: data,
            cache: true,
            onPrepend: function () {
                var options = {
                    lazyLoad: 'progressive',
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 1190,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ],
                    nextArrow: $('#pdp-zoom-modal').find('.slick-next'),
                    prevArrow: $('#pdp-zoom-modal').find('.slick-prev')
                };

                $('.js-slides-zoom').slides(options);
            }
        });
    }
});

// (Mostly) from shoppingbag/index.js
// Will refactor in follow-up ticket
window.loadForwardMultipleQuickViewPdp = (event, codes, sbsrc) => {
    var requestURL = window.location.href;
    var isMens = window.location.href.indexOf('d=Mens') != -1;
    var dParam = isMens? 'Mens' : 'Womens';
    var paramObj = {
        codes : codes,
        d : dParam,
        requestUrl : requestURL
    };
    if(sbsrc){
        paramObj.sbsrc = sbsrc;
    }
    var data= $.param(paramObj);

    $.modal({
        url: "/fw/ajax/multiItemQuickview.jsp",
        data: data,
        triggerOpen: true,
        returnFocus: $(event.currentTarget),
        onComplete : function () {
            /*
            quickViewDisplayCallBack(carouselType, $triggerTarget);
             */
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/index.js